import { Component, signal } from '@angular/core';
import { PROPERTY_SETS_DIALOG_ACTIONS } from '../property-sets-dialog-actions/property-sets-dialog-actions';
import { PropertySetListDialogActionsService } from './property-set-list-dialog-actions.service';
import { PropertySetListService } from './property-set-list.service';
import { PropertySet } from '@miq/domain/property-sets';
import { Filter } from '@cbre/components';
import { take } from 'rxjs';
import { SortingSelection } from '../common/sorting.model';

@Component({
  selector: 'miq-property-set-list',
  template: ` <!-- title -->
    <miq-property-sets-dialog-actions></miq-property-sets-dialog-actions>
    <div class="fx--v ps-list-wrapper">
      <div class="fx--padding-20 fx--pb-xs fx--bg__light-gray">
        <miq-property-set-filters (filterChange)="onFiltersChange($event)"></miq-property-set-filters>
      </div>
      <div class="fx--v ps-list-table-wrapper">
        <miq-property-set-table [propertySets]="$propertySets()"></miq-property-set-table>
      </div>
    </div>`,
  providers: [
    PropertySetListService,
    { provide: PROPERTY_SETS_DIALOG_ACTIONS, useClass: PropertySetListDialogActionsService },
  ],
  styleUrls: ['./property-set-list.component.scss'],
  standalone: false,
})
export class PropertySetListComponent {
  searchConfigs: { filters: Filter[]; limit: number; sort?: SortingSelection; offset?: number };
  $propertySets = signal<PropertySet[]>([]);
  constructor(private propertySetListService: PropertySetListService) {
    this.searchConfigs = {
      filters: [],
      limit: 1000,
      offset: 0,
    };
  }

  onFiltersChange(filters: Filter[] = []): void {
    this.searchConfigs.filters = filters;
    this.search();
  }

  search() {
    const { filters, limit, offset } = this.searchConfigs;
    const psSource$ = this.propertySetListService.findByFilter(filters, { limit, offset });
    psSource$.pipe(take(1)).subscribe(propertySets => this.$propertySets.set(propertySets));
  }
}
